<template>
  <div>
    <div class="row q-gutter-sm justify-end q-mb-xs">
      <div v-show="!isLocal" class="col">
        <q-btn
          v-if="canEdit && false"
          v-show="!isLocal"
          color="red"
          icon="create"
          label="轉詢價單"
          @click="handlePostToAsk"
        ></q-btn>
      </div>
      <div class="col col-xs-5 col-md-1 col-xl-1">
        <q-btn
          v-if="canEdit && showInquiry"
          color="red"
          icon="create"
          label="轉本地詢價單"
          @click="isLocalInquiry = '2', handlePostToAsk()"
        ></q-btn>
      </div>
      <div class="col col-xs-5 col-md-1 col-xl-1">
        <q-btn
          v-if="canEdit"
          color="blue"
          icon="save"
          label="儲存建議書"
          @click="suggestSave"
        ></q-btn>
      </div>
      <div class="col col-xs-5 col-md-1 col-xl-1">
        <q-btn
          v-if="canEdit"
          color="red"
          icon="delete"
          label="清除所有項目"
          @click="handleSuggestDeleteAll"
        ></q-btn>
      </div>
      <div class="col col-xs-5 col-md-1 col-xl-1">
        <q-btn
          v-if="canEdit"
          color="green"
          icon="add"
          label="新增採購項目"
          @click="handleAddProduct"
        ></q-btn>
      </div>
    </div>
    <q-table
      v-if="suggestList"
      title="庫存不足產品"
      virtual-scroll
      :style="listStyle"
      :data="suggestList"
      :columns="columns"
      row-key="name"
      :pagination.sync="tableSet"
    >
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td key="category" :props="props">{{ props.row.productDetail.Category.title }}</q-td>
          <q-td key="title" :props="props"><ProductTitle :product-data="props.row.productDetail" /></q-td>
          <q-td key="nickName" :props="props">{{ props.row.productDetail.nick_name }}</q-td>
          <q-td key="safeStock" :props="props">{{ props.row.productDetail.safe_stock }}</q-td>
          <q-td key="stock" :props="props">{{ props.row.stock }}</q-td>
          <q-td key="buy" :props="props">
            <q-input v-model="props.row.suggest_stock" type="number" style="text-align: center"></q-input>
          </q-td>
          <q-td key="price" :props="props">
            <q-input v-model="props.row.price"></q-input>
          </q-td>
          <q-td key="note" :props="props">
            <q-input type="textarea" v-show="isLocal" v-model="props.row.note"></q-input>
          </q-td>
          <q-td key="action" :props="props">
            <q-btn
              v-if="canEdit"
              color="red"
              icon="delete"
              style="margin-left: 5px;"
              @click="handleSuggestDelete(props.row)"
            ></q-btn>
          </q-td>
        </q-tr>
      </template>
    </q-table>
    <SuggestSearch :is-show="searchShow" :is-local="isLocal" @updateSearchShow="handleSearchShow"/>
  </div>

</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import SuggestSearch from './SuggestSearch'
  import { showSystemNotify } from "@/utils";
  import ProductTitle from '@/components/ProductTitle'

  export default {
    props: {
      isList: {
        type: Boolean,
        default: true
      },
      isLocal: {
        type: Boolean,
        default: true
      },
      canEdit: {
        type: Boolean,
        default: false
      }
    },
    name: "SuggestProduct",
    components: { SuggestSearch, ProductTitle },
    computed: {
      ...mapGetters(['suggestList'])
    },
    data() {
      return {
        searchShow: false,
        isLocalInquiry: "1", // 1 ===> 線上 2 ===> 本地
        listStyle: "",
        showInquiry: true,
        columns: [
          // { name: 'status', align: 'center', label: '是否啟用', field: 'status', sortable: true,},
          { name: 'category', label: '分類', sortable: true },
          { name: 'title', align: 'center', label: '產品名稱', field: 'title', sortable: true },
          { name: 'nickName', label: '物料暱稱', field: 'nick_name', sortable: true },
          { name: 'safeStock', label: '安全庫存', field: 'safe_stock', sortable: true },
          { name: 'stock', label: '庫存', sortable: true },
          { name: 'buy', align: 'center', label: '採購數量' },
          { name: 'price', align: 'center', label: '價格' },
          { name: 'note', align: 'center', label: '備註' },
          { name: 'action', label: '操作', align: 'center', field: 'id' }
        ],
        tableSet: {
          sortBy: 'desc',
          descending: false,
          page: 1,
          rowsPerPage: 10
          // rowsNumber: xx if getting data from a server
        },
      }
    },
    created() {
      if ( !this.isList ) {
        this.tableSet.rowsPerPage = 5
        this.listStyle = `height: 390px;`
      }else {
        this.listStyle = `height: 550px;`
      }
      this.$store.dispatch('suggestGetList')
        .then(_ => {
          const pathSplit = this.$route.path.split("/")
          let suggestProductIDs = []
          if (pathSplit[2] === 'offline-create') {
            this.showInquiry = false
            
          }
          //獲取最後進價
          this.suggestList.map((r) => {
            // 已經輸入過的就不在讀最後進價
            if (r.price === 0) {
              suggestProductIDs.push(r.product_id)
            }
          })
          this.$store.dispatch('purchaseLocalGetLastPrice', suggestProductIDs)
            .then(res =>{
              res.List.map(row => {
                this.suggestList.map(s => {
                  if (s.product_id === row.product_id) {
                    s.price = row.answer_price
                  }
                })
                
              })
            })
        })
    },
    methods: {
      handleAddProduct() {
        this.$set(this, 'searchShow', true)
      },
      handleSuggestDelete(row) {
        this.$q.dialog({
          dark: true,
          title: '確認！',
          message: '是否確定要刪除此物料？',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.$store.dispatch('suggestDeleteOne', row).then(res => {
            showSystemNotify(res)
          })
        })
      },
      handlePostToAsk() {
        // 轉存為詢價單
        this.$store.dispatch('suggestToInquiry', this.isLocalInquiry)
      },
      handleSuggestDeleteAll() {
        this.$q.dialog({
          dark: true,
          title: '確認！',
          message: '是否確定要刪除所有物料？',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.$store.dispatch('suggestDeleteAll')
        })
      },
      countStockTotal(stocks) {
        let total = 0
        stocks.map(row => total += parseInt(row.Stock))
        return total
      },
      handleSearchShow() {
        this.$set(this, 'searchShow', false)
      },
      ...mapActions(['suggestSave', 'suggestDeleteOne'])
    }
  }
</script>

<style scoped>

</style>
